import { captureException } from '@sentry/browser';

function logError(error) {
    console.error(error);

    if (!error) {
        return null;
    }

    const exception = error.originalError || error.error || error;

    return captureException(exception);
}

export {
    logError
}
